///////////////////////////////////////////////
//       Carousel component styling          //
///////////////////////////////////////////////

@import './pk-carousel.variables';

:host {
  @apply block;
}

.pk-carousel {
  @apply z-[1] block;
  // We cannot directly `@apply` the `relative` Tailwind utility because it gives an error:
  // "You cannot `@apply` the `relative` utility here because it creates a circular dependency."
  position: relative;

  &.navigation-aside {
    @apply md:px-xl2;
  }

  &.navigation-mobile {
    &.navigation-aside {
      @apply px-xl2;
    }

    .pk-carousel--navigation__prev,
    .pk-carousel--navigation__next {
      @apply block;
    }
  }
}

.pk-carousel--header .headline {
  @apply pl-0 text-[length:--carousel--headline-size-mobile] leading-[--carousel--headline-line-height] text-[color:--carousel--headline-color];
  @apply sm:text-[length:--carousel--headline-size];

  font-family: var(--carousel--headline-font);
}

.pk-carousel--navigation {
  &.position-aside,
  &.position-inside {
    @apply absolute left-0 top-[calc(50%-16px)] box-border w-full justify-between;

    .pk-carousel--navigation__next {
      @apply ml-0;
    }
  }
}

.pk-carousel--navigation__prev,
.pk-carousel--navigation__next {
  @apply hidden md:block;

  &.pk-carousel--navigation-lock {
    @apply hidden;
  }
}

.pk-carousel--navigation__next {
  @apply ml-[--carousel--arrows-spacing];
}

.scale-spacing {
  @apply px-[--carousel--scale-outer-spacing] py-[--carousel--scale-outer-spacing];
  @apply -mx-[--carousel--scale-outer-spacing] -my-[--carousel--scale-outer-spacing];
}

.pk-carousel--container {
  &:not(.pk-carousel--container__initialized) {
    .pk-carousel--container__wrapper {
      @apply opacity-0;

      .pk-carousel--slide {
        @apply flex-1;
      }
    }
  }

  &.box-shadow-padding {
    @apply px-[--pk-spacing-xs] pb-[--pk-spacing-m];
    @apply -mx-[--pk-spacing-xs] -mb-[--pk-spacing-m] mt-[--carousel--container-margin-top];
  }

  &.scale-slides {
    ::slotted(.pk-carousel--slide):hover {
      transform: scale(var(--carousel--scale-level)); // tailwind was scaling all slides at once
    }
  }

  &.navigation-inside {
    .pk-carousel--navigation__prev,
    .pk-carousel--navigation__next {
      @apply absolute top-[50%] z-10 translate-y-[-50%] transition-[opacity] delay-100;

      // hide only on hover devices
      @media (hover: hover) {
        @apply z-[-1] opacity-0;
      }
    }

    .pk-carousel--navigation__prev {
      @apply left-s;
    }

    .pk-carousel--navigation__next {
      @apply right-s;
    }

    &:hover {
      .pk-carousel--navigation__prev,
      .pk-carousel--navigation__next {
        @apply z-10 opacity-100;
      }
    }
  }
}

.pk-carousel--container__wrapper {
  @apply ease-[cubic-bezier(0.33,0.66,0.66,1)];

  ::slotted(.pk-carousel--slide) {
    @apply flex h-auto w-auto transition-transform duration-300;
  }
}

.pk-carousel--cta {
  @apply mt-[--carousel--footer-margin-top] p-0;
}

.pk-carousel__pagination {
  @apply absolute bottom-[--carousel--pagination-bottom] left-[--carousel--pagination-left] z-10 flex w-full justify-center;
  text-align: var(--carousel--pagination-align);

  &--bullet {
    @apply m-[--pk-spacing-xs2] inline-block h-xs w-xl2 rounded-[--carousel--pagination-border-radius] bg-[color:--pk-ui-03] hover:cursor-pointer;
  }

  &--bullet-active {
    @apply bg-[color:--pk-interaction-high-contrast];
  }

  &--lock {
    @apply hidden;
  }
}

.pk-carousel__static-item {
  @apply absolute left-0 z-10 hidden scale-[--first-slide--fade-out] opacity-[--first-slide--fade-out] transition-[transform,opacity] ease-linear sm:block;

  &.scale-enabled {
    @apply left-[--carousel--scale-outer-spacing];
  }
}

.pk-carousel--slide.mask {
  @apply hidden sm:flex;
}
